import { render } from "./AssistantChatWidget.vue?vue&type=template&id=475c0e7e&scoped=true"
import script from "./AssistantChatWidget.vue?vue&type=script&lang=js"
export * from "./AssistantChatWidget.vue?vue&type=script&lang=js"

import "./AssistantChatWidget.vue?vue&type=style&index=0&id=475c0e7e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475c0e7e"]])

export default __exports__